import React from "react";

import { Footer } from "~/components/ui/footer";
import { Header } from "~/components/ui/header";

/**
 * The full Dream Coach Match site chrome (main nav header + footer) used to
 * wrap the public coach experience: profile, resources, booking, and contact.
 * Offer pages deliberately opt out of this in favor of the lighter,
 * conversion-focused {@link OfferPageChrome}.
 */
export function CoachSiteChrome({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col justify-between">
      <Header />
      <div className="z-10 grow">{children}</div>
      <Footer />
    </div>
  );
}
